/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RoleCountResponse } from '../../models/role-count-response';

export interface RoleCount$Params {
}

export function roleCount(http: HttpClient, rootUrl: string, params?: RoleCount$Params, context?: HttpContext): Observable<StrictHttpResponse<RoleCountResponse>> {
  const rb = new RequestBuilder(rootUrl, roleCount.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RoleCountResponse>;
    })
  );
}

roleCount.PATH = '/api/v2/role-count';
